<template>
  <div class="users-root">
    <div class="actions">
      <template v-if="activeTab == 'users'">
        <el-button type="primary" size="large" @click="handleInviteUser"
          >+&nbsp;邀请新成员</el-button
        >
        <el-input
          placeholder="搜索用户名"
          size="large"
          v-model="userSearchTerm"
          style="width: 240px; margin-left: 20px"
        >
          <template #suffix>
            <i class="iconfont icon-sousuo"></i>
          </template>
        </el-input>
      </template>

      <template v-if="activeTab == 'groups'">
        <el-button type="primary" size="large" @click="handleNewGroup"
          >+&nbsp;创建测试组</el-button
        >
        <el-input
          placeholder="搜索群组"
          size="large"
          v-model="groupSearchTerm"
          style="width: 240px; margin-left: 20px"
        >
          <template #suffix>
            <i class="iconfont icon-sousuo"></i>
          </template>
        </el-input>
      </template>
    </div>

    <TakoPanel :header="false" class="panel">
      <el-tabs v-model="activeTab" @tab-click="handleChangeTab">
        <el-tab-pane name="users">
          <template #label><span style="font-size: 18px">人员</span></template>
          <UsersTable ref="usersTableRef" :filter="userSearchTermFuzzy" />
          <UserEdit
            title="邀请成员"
            type="invite"
            ref="inviteUserRef"
            key="inviteUser"
            @submit-success="reloadUsersAndGroups"
          />
        </el-tab-pane>

        <el-tab-pane name="groups">
          <template #label><span style="font-size: 18px">群组</span></template>
          <GroupsTable ref="groupsTableRef" :filter="groupSearchTermFuzzy" />
          <GroupEdit
            title="创建测试组"
            type="new"
            ref="newGroupRef"
            key="newGroup"
            @submit-success="reloadUsersAndGroups"
          />
        </el-tab-pane>
      </el-tabs>
    </TakoPanel>
  </div>
</template>

<script setup>
import { computed, nextTick, ref } from "vue";
import { useProjectStore } from "@/Store/ProjectStore";
import TakoPanel from "@/Components/TakoPanel.vue";
import UsersTable from "./Users/UsersTable.vue";
import UserEdit from "./Users/UserEdit.vue";
import GroupsTable from "./Users/GroupsTable.vue";
import GroupEdit from "./Users/GroupEdit.vue";

const projectStore = useProjectStore();

const activeTab = ref("users");
const userSearchTerm = ref("");
const groupSearchTerm = ref("");

const userSearchTermFuzzy = computed(() => userSearchTerm.value.toLowerCase());
const groupSearchTermFuzzy = computed(() => groupSearchTerm.value.toLowerCase());

const inviteUserRef = ref(null);
function handleInviteUser() {
  inviteUserRef.value.show();
}

const newGroupRef = ref(null);
function handleNewGroup() {
  newGroupRef.value.show();
}

const usersTableRef = ref(null);
const groupsTableRef = ref(null);
function handleChangeTab(tab) {
  nextTick(() => {
    if (tab.name == "users") {
      usersTableRef.value.doLayout();
    } else if (tab.name == "groups") {
      groupsTableRef.value.doLayout();
    }
  });
}

function reloadUsersAndGroups() {
  projectStore.getTestUsers();
  projectStore.getTestGroups();
}
</script>

<style lang="scss" scoped>
.users-root {
  padding: 20px;
  position: relative;
}

.actions {
  width: fit-content;
  position: absolute;
  right: 40px;
  top: 30px;
  z-index: 20;
}

.panel {
  padding: 20px;
}

.table-actions-left {
  display: inline-block;
  text-align: left;
}

.table-actions-right {
  display: inline-block;
  text-align: right;
}
</style>
